<template>
	<div class="bg-white border rounded-lg p-4">
		<div class="mb-4">
			<h6 class="text-lg uppercase tracking-wider text-gray-500 mb-1">
				Praguri elemente mici
			</h6>
			<v-label class="text-base">
				Suprafata minima (m² / bucata). Sub prag se aplica un adaos pe bucata. Plafonat la max. * 1.3
			</v-label>
		</div>

		<v-form v-model="validForm" ref="formMinArea" @submit.prevent="save">
			<div class="flex flex-wrap gap-2">
				<v-text-field v-for="element in elementKeys" :key="element" v-model="areas[element]"
					class="w-36 flex-grow-0" dense type="number" min="0" step="0.1" hide-spin-buttons outlined
					:label="labels[element]" suffix="m²" :rules="[rules.required, rules.positive]"></v-text-field>
			</div>

			<div class="flex justify-end">
				<v-btn type="submit" color="teal" class="uppercase white--text" :loading="saving"
					:disabled="saving || !hasChanges">Salveaza</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import pricingSection from './pricingSection';

export default {
	name: "MinArea",
	mixins: [pricingSection],
	data() {
		return {
			validForm: false,
			elementKeys: ['panel', 'pedestrian', 'driveway'],
			labels: {
				panel: 'Panou',
				pedestrian: 'Poarta pietonala',
				driveway: 'Poarta auto'
			},
			areas: {},
			rules: {
				required: value => (value !== '' && value !== null && value !== undefined) || 'Câmp obligatoriu',
				positive: value => (!isNaN(parseFloat(value)) && parseFloat(value) > 0) || 'Valoare mai mare ca 0',
			},
		};
	},
	computed: {
		saving() {
			return this.section.savingPricingConfig;
		},
		minArea() {
			return this.section.pricingConfig.minArea;
		},
		hasChanges() {
			const payload = this.buildPayload();
			return this.elementKeys.some(element => payload[element] !== this.minArea[element]);
		}
	},
	methods: {
		syncFromStore() {
			const areas = {};
			this.elementKeys.forEach(element => {
				areas[element] = this.minArea[element];
			});
			this.areas = areas;
		},
		buildPayload() {
			const payload = {};
			this.elementKeys.forEach(element => {
				payload[element] = Number(parseFloat(this.areas[element]).toFixed(2));
			});
			return payload;
		},
		async save() {
			const valid = await this.$refs.formMinArea.validate();

			if (valid) {
				// full replace of the column, all three keys are always sent
				this.dispatchSection('savePricingConfig', { minArea: this.buildPayload() });
			}
		}
	},
	watch: {
		minArea: {
			handler: 'syncFromStore',
			deep: true
		}
	},
	created() {
		this.syncFromStore();
	}
};
</script>

<style scoped></style>
